var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { I18NLink } from "../../I18N";
import SearchDescription from "../../Library/components/SearchDescription";
import { withContext } from "../../componentWrappers";
import { Icon, ProgressBar } from "../../UI";

import { deleteSearch, resumeSearch, stopSearch } from "../actions/actions";

class SearchItemComponent extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
    this.handleResumeClicked = this.handleResumeClicked.bind(this);
    this.handleStopClicked = this.handleStopClicked.bind(this);
  }

  handleStopClicked(e) {
    const { search, onStopClicked } = this.props;
    onStopClicked(search._id);
    e.preventDefault();
  }

  handleResumeClicked(e) {
    const { search, onResumeClicked } = this.props;
    onResumeClicked(search._id);
    e.preventDefault();
  }

  delete(e) {
    const { onDeleteClicked, search } = this.props;
    e.preventDefault();
    this.props.mainContext.confirm({
      accept: onDeleteClicked.bind(this, search._id),
      title: 'Confirm delete',
      message: 'Are you sure you want to delete this search?'
    });
  }

  renderButtons() {
    const { search } = this.props;
    const { status } = search;
    return /*#__PURE__*/(
      _jsx("div", { className: "buttons" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-danger delete-search btn-xs", onClick: this.delete }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "trash-alt", size: "sm" })
      ),
      ['inProgress', 'pending'].includes(status) && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-warning stop-search btn-xs",
        onClick: this.handleStopClicked }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "stop", size: "sm" })
      ),

      status === 'stopped' && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-success resume-search btn-xs",
        onClick: this.handleResumeClicked }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "play", size: "sm" })
      )

      ));

  }

  render() {
    const { search } = this.props;
    const { status, documents } = search;
    const completed = documents.filter((doc) => doc.status === 'completed').length;
    const max = documents.length;
    return /*#__PURE__*/(
      _jsx(I18NLink, { className: "semantic-search-list-item", to: `semanticsearch/${search._id}` }, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-header" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "title" }, void 0, /*#__PURE__*/
      _jsx(SearchDescription, { searchTerm: search.searchTerm, query: search.query })
      ),
      this.renderButtons()
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, status !== 'completed' && /*#__PURE__*/_jsx(ProgressBar, { value: completed, max: max }))
      ));

  }
}

















function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onDeleteClicked: deleteSearch,
      onStopClicked: stopSearch,
      onResumeClicked: resumeSearch
    },
    dispatch
  );
}

const SearchItem = connect(null, mapDispatchToProps)(withContext(SearchItemComponent));
export { SearchItemComponent, mapDispatchToProps, SearchItem };